import { render } from "./AppAdminLayout.vue?vue&type=template&id=0f7178af"
import script from "./AppAdminLayout.vue?vue&type=script&lang=js"
export * from "./AppAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__